
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/kurse",
      function () {
        return require("private-next-pages/[domain]/kurse/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/kurse"])
      });
    }
  